// Older merchants inherit their Accounting state until Finance is explicitly set.
export const moduleState = (modules, key, defaults = {}) => {
  if (key === "sister_companies") return modules?.[key] || defaults[key] || "DISABLED";
  if (key === "finance_operations") return modules?.[key] || modules?.accounting || defaults[key] || defaults.accounting || "DISABLED";
  return modules?.[key] || defaults[key] || (key === "accounting" ? "DISABLED" : "ENABLED");
};

export const moduleEnabled = (modules, key) =>
  !key || (["ENABLED", "READ_ONLY"].includes(moduleState(modules, key)) && (key !== "finance_operations" || ["ENABLED", "READ_ONLY"].includes(moduleState(modules, "accounting"))));

export const moduleReadOnly = (modules, key) => moduleState(modules, key) === "READ_ONLY" || (key === "finance_operations" && moduleState(modules, "accounting") === "READ_ONLY");

export const featureEnabled = (features, key) => {
  if (key?.startsWith("finance_operations.") && !featureEnabled(features, "accounting.general_ledger")) return false;
  if (key?.startsWith("accounting.") && key !== "accounting.general_ledger" && !featureEnabled(features, "accounting.general_ledger")) return false;
  if (!key || features?.[key] == null) return key !== "api_access.external_integrations";
  const feature = features[key];
  return typeof feature === "object" ? feature.enabled !== false : feature !== false;
};
